import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ErrorMessage,
  FilterValues,
  FinancialAccountActivityItem,
  FinancialAccountJournalActivityItem,
  RequestPageParams,
  TransactionDetails,
  TransactionHistory,
  TransactionListItem,
  TransactionListRequest,
  TransactionStatusUpdateParams,
} from '@shared/models';

export const TransactionsActions = createActionGroup({
  source: 'Transactions Actions',
  events: {
    'Load Transactions': props<{ params: TransactionListRequest }>(),
    'Load Transactions Success': props<{ transactions: TransactionListItem[]; totalElements: number }>(),
    'Load Transactions Failure': props<{ error: string }>(),
    'Update Transaction Status': props<{ params: TransactionStatusUpdateParams }>(),
    'Update Transaction Status Success': emptyProps,
    'Update Transaction Status Error': props<{ error: string }>(),
    'Set Transactions Active Filters': props<{ filters: FilterValues }>(),
    'Load Business Account Transactions': props<{ params: TransactionListRequest }>(),
    'Load Business Account Transactions Success': props<{ transactions: TransactionListItem[]; totalElements: number }>(),
    'Load Business Account Transactions Failure': props<{ error: string }>(),
    'Set Business Account Transactions Active Filters': props<{ filters: FilterValues }>(),
    'Load Transaction Details': emptyProps,
    'Load Transaction Details Success': props<{ transactionDetails: TransactionDetails }>(),
    'Load Transaction Details Failure': props<{ error: ErrorMessage }>(),
    'Load Transaction History Success': props<{ transactionHistory: TransactionHistory[]; businessAccountId?: string }>(),
    'Load Transaction History Failure': props<{ error: ErrorMessage }>(),
    'Load Journal Activity': props<{ params: RequestPageParams }>(),
    'Load Journal Activity Success': props<{ items: FinancialAccountJournalActivityItem[]; totalElements: number }>(),
    'Load Journal Activity Failure': props<{ error: string }>(),
    'Set Journal Activity Active Filters': props<{ filters: FilterValues }>(),
    'Load Ledger Entries': props<{ params: RequestPageParams }>(),
    'Load Ledger Entries Success': props<{ items: FinancialAccountActivityItem[]; totalElements: number }>(),
    'Load Ledger Entries Failure': props<{ error: string }>(),
    'Set Ledger Entries Active Filters': props<{ filters: FilterValues }>(),
  },
});
